import { PriceAdjustment, AttributePriceType } from "./types";

export function calculatePrice(
  adjustments: PriceAdjustment[],
  basePrice: number
): number {
  let attributePriceAdjustments = 0;

  for (const adj of adjustments) {
    switch (adj.PriceType) {
      case AttributePriceType.Add:
        attributePriceAdjustments += adj.Price;
        break;

      case AttributePriceType.Subtract:
        attributePriceAdjustments -= adj.Price;
        break;

      case AttributePriceType.Override:
        return adj.Price; // Overrides entire price
    }
  }

  const total = attributePriceAdjustments + basePrice;
  return total < 0 ? 0 : total;
}
